<template>
  <div
    :data-test-id="`base-snackbar base-snackbar-${variant}`"
    class="flex w-full min-w-0 items-center gap-3 py-1 text-sm"
  >
    <v-icon :class="iconColorClass" size="22">
      {{ iconName }}
    </v-icon>

    <div
      class="min-w-0 flex-1 whitespace-pre-wrap break-words font-medium text-grey-900"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { INotificationType } from '@manager/modules/snackbar/snackbar-types';
import { computed } from 'vue';

interface Props {
  variant?: INotificationType;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'success',
});

const iconName = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'mdi-check-circle-outline';
    case 'error':
      return 'mdi-alert-circle-outline';
    case 'info':
      return 'mdi-information-outline';
  }
  return 'mdi-information-outline';
});

const iconColorClass = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'text-app-success';
    case 'error':
      return 'text-app-danger';
    case 'info':
      return 'text-app-primary';
  }
  return 'text-app-primary';
});
</script>
